import toman from "../../assets/icons/toman.svg";

import iban from "../../assets/icons/iban.svg";
import arrow from "../../assets/icons/arrow.svg";
import sadEmoji from "../../assets/icons/emoji-sad.svg";
import plus from "../../assets/icons/plus-icon.svg";
import pos_statements from "../../assets/icons/pos-statments.svg";
import neg_statements from "../../assets/icons/neg-statments.svg";
import statements_arrow from "../../assets/icons/statements-arrow.svg";
import search from "../../assets/icons/search.svg";
import excel from "../../assets/icons/excel.svg";
import info from "../../assets/icons/info.svg";
import list from "../../assets/icons/list.svg";
import teter from "../../assets/icons/teter.svg";
import setting from "../../assets/icons/setting.svg";
import withdraw from "../../assets/icons/money-withdraw.svg";
import home from "../../assets/icons/dashboard.svg";
import person from "../../assets/icons/person.svg";
import security from "../../assets/icons/security.svg";
import logout from "../../assets/icons/logout.svg";
import edit from "../../assets/icons/edit.svg";
import active from "../../assets/icons/active.svg";
import checked from "../../assets/icons/checked.svg";
import video from "../../assets/icons/video.svg";
import key from "../../assets/icons/key.svg";
import tow_step from "../../assets/icons/tow-step.svg";
import bank_card from "../../assets/icons/bank_card.svg";
import trash from "../../assets/icons/trash.svg";
import rial from "../../assets/icons/rial.svg";

export default {
  key,
  tow_step,
  bank_card,
  trash,
  toman,
  info,
  iban,
  arrow,
  sadEmoji,
  plus,
  pos_statements,
  neg_statements,
  statements_arrow,
  search,
  excel,
  setting,
  list,
  teter,
  withdraw,
  home,
  person,
  security,
  logout,
  checked,
  active,
  edit,
  video,
  rial
};
